(function () {
  'use strict';

  // ============================================================
  //  i18n bridge — reads the JSON island emitted by Liquid
  //  Decodes HTML entities (Shopify's t-filter escapes ' " & < >).
  // ============================================================
  function decodeEntities(s) {
    if (typeof s !== 'string') return s;
    return s
      .replace(/&#39;/g, "'")
      .replace(/&#34;/g, '"')
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&nbsp;/g, ' ');
  }
  function deepDecode(v) {
    if (typeof v === 'string') return decodeEntities(v);
    if (Array.isArray(v)) return v.map(deepDecode);
    if (v && typeof v === 'object') {
      const out = {};
      for (const k of Object.keys(v)) out[k] = deepDecode(v[k]);
      return out;
    }
    return v;
  }

  let __ymI18nTree = {};
  try {
    const el = document.getElementById('ym-quiz-i18n');
    if (el) __ymI18nTree = deepDecode(JSON.parse(el.textContent || '{}'));
  } catch (e) {}

  window.__ymI18n = function (key, fallback) {
    const parts = key.replace(/^quiz\./, '').split('.');
    let cur = __ymI18nTree;
    for (const p of parts) {
      if (cur == null || typeof cur !== 'object') return fallback;
      cur = cur[p];
    }
    return (typeof cur === 'string') ? cur : fallback;
  };

  window.__ymTree = function (key) {
    const parts = key.replace(/^quiz\./, '').split('.');
    let cur = __ymI18nTree;
    for (const p of parts) {
      if (cur == null || typeof cur !== 'object') return null;
      cur = cur[p];
    }
    return cur;
  };

  // ============================================================
  //  Hardcoded per-locale lists (styles, voices, occasions)
  //  These come from the design spec — kept here because Shopify
  //  locale files cannot store arrays as leaf values.
  // ============================================================
  const LISTS = {
    fr: {
      styles: [
        "Variété française", "Surprenez-moi", "Ballade romantique", "Piano",
        "Country", "Pop", "R&B", "Rap", "Rock", "Autre (Précisez plus bas)",
        "Ouverture de bal / Mariage", "Oriental", "Latino", "Afro beats",
        "Métal", "Soul", "Reggae", "Disco", "Classique", "Orchestre"
      ],
      voices: ["Chanteuse", "Chanteur", "Surprenez-moi"],
      occasions: [
        "Anniversaire", "Mariage", "Saint-Valentin", "Fête des Mères",
        "Fête des Pères", "Naissance", "Noël", "Demande en mariage",
        "Anniversaire de mariage", "Juste parce que", "Autre"
      ]
    },
    en: {
      styles: [
        "Surprise Me", "Indie", "Romantic Ballad", "Piano", "Country", "Folk",
        "R&B", "Pop", "Rap / Hip-Hop", "Rock", "Blues", "Other (Specify below)",
        "First Dance / Wedding", "Gospel", "Oriental", "Latin", "Afro Beats",
        "Metal", "Soul", "Reggae", "Disco", "Classical", "Orchestra"
      ],
      voices: ["Female singer", "Male singer", "Surprise me"],
      occasions: [
        "Birthday", "Wedding", "Valentine's Day", "Mother's Day", "Father's Day",
        "Birth", "Christmas", "Proposal", "Wedding Anniversary", "Just because", "Other"
      ]
    },
    de: {
      styles: [
        "Überrasche mich", "Schlager", "Deutschpop", "Romantische Ballade",
        "Rock-Folk", "Klavier", "Pop", "Country", "R&B", "Rap", "Rock",
        "Alternative Rock", "Andere (unten angeben)", "Eröffnungstanz / Hochzeit",
        "Orientalisch", "Latino", "Afrobeats", "Metal", "Soul", "Reggae",
        "Disco", "Klassik", "Orchester"
      ],
      voices: ["Sängerin", "Sänger", "Überrasche mich"],
      occasions: [
        "Geburtstag", "Hochzeit", "Valentinstag", "Muttertag", "Vatertag",
        "Geburt", "Weihnachten", "Heiratsantrag", "Hochzeitstag", "Einfach so", "Andere"
      ]
    }
  };

  // ============================================================
  //  Line item property labels per locale
  //  (visible to customer in cart/checkout AND to merchant in admin)
  // ============================================================
  const PROP_LABELS = {
    fr: {
      recipient: 'Pour qui',
      firstName: 'Prénom',
      style: 'Style',
      voice: 'Voix',
      occasion: 'Occasion',
      qualities: 'Qualités',
      memories: 'Souvenirs',
      difficulties: 'Difficultés',
      message: 'Message',
      songTitle: 'Titre de la chanson',
      artist: 'Artiste',
      socle: 'Socle',
      yes: 'Oui'
    },
    en: {
      recipient: 'For whom',
      firstName: 'First name',
      style: 'Music style',
      voice: 'Voice',
      occasion: 'Occasion',
      qualities: 'Qualities',
      memories: 'Memories',
      difficulties: 'Hard times',
      message: 'Message',
      songTitle: 'Song title',
      artist: 'Artist',
      socle: 'Wooden base',
      yes: 'Yes'
    },
    de: {
      recipient: 'Für wen',
      firstName: 'Vorname',
      style: 'Musikstil',
      voice: 'Stimme',
      occasion: 'Anlass',
      qualities: 'Eigenschaften',
      memories: 'Erinnerungen',
      difficulties: 'Schwere Zeiten',
      message: 'Botschaft',
      songTitle: 'Liedtitel',
      artist: 'Künstler',
      socle: 'Holzsockel',
      yes: 'Ja'
    }
  };

  // ============================================================
  //  State machine
  // ============================================================
  const STORAGE_KEY = 'ym_lead_state_v1';
  const STATE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  const STEPS = [
    'step-1', 'step-2', 'step-3',
    'step-4', 'step-5', 'step-6', 'step-7',
    'lead-capture'
  ];

  // Hardcoded copy for the lead-capture step (no Shopify locale keys needed).
  const LEAD_COPY = {
    fr: {
      stepLabel: "Dernière étape",
      title: "Recevez votre extrait gratuit",
      subtitle: "Renseignez vos coordonnées. Vous recevrez votre chanson personnalisée par email et SMS d'ici 30 minutes à 1h.",
      firstNameLabel: "Votre prénom",
      firstNamePlaceholder: "Ex. Thomas",
      lastNameLabel: "Votre nom",
      lastNamePlaceholder: "Ex. Martin",
      emailLabel: "Votre email",
      emailPlaceholder: "vous@exemple.fr",
      phoneLabel: "Votre numéro de téléphone",
      phonePlaceholder: "6 12 34 56 78",
      countryCodeLabel: "Indicatif",
      ctaSubmit: "Recevoir mon extrait gratuit",
      submittingLabel: "Création de votre chanson…",
      consentHint: "En soumettant ce formulaire, vous acceptez de recevoir votre extrait par email et SMS. Pas de spam, votre chanson uniquement.",
      successTitle: "Votre extrait est en cours de création",
      successBody: "Vous recevrez votre chanson personnalisée par <strong>email</strong> et <strong>SMS</strong> d'ici 30 minutes à 1h.",
      successHint: "Pensez à vérifier vos spams si vous ne recevez rien après 1h.",
      errorGeneric: "Une erreur est survenue. Vérifiez votre connexion et réessayez.",
      errorEmail: "Veuillez saisir une adresse email valide.",
      errorPhone: "Veuillez saisir un numéro de téléphone valide."
    },
    en: {
      stepLabel: "Last step",
      title: "Get your free preview",
      subtitle: "Enter your details. You'll receive your personalized song by email and SMS within 30 minutes to 1 hour.",
      firstNameLabel: "Your first name",
      firstNamePlaceholder: "e.g. Thomas",
      lastNameLabel: "Your last name",
      lastNamePlaceholder: "e.g. Martin",
      emailLabel: "Your email",
      emailPlaceholder: "you@example.com",
      phoneLabel: "Your phone number",
      phonePlaceholder: "555 123 4567",
      countryCodeLabel: "Country code",
      ctaSubmit: "Get my free preview",
      submittingLabel: "Creating your song…",
      consentHint: "By submitting this form, you agree to receive your preview by email and SMS. No spam, only your song.",
      successTitle: "Your preview is being created",
      successBody: "You'll receive your personalized song by <strong>email</strong> and <strong>SMS</strong> within 30 minutes to 1 hour.",
      successHint: "Check your spam folder if you don't receive anything after 1 hour.",
      errorGeneric: "Something went wrong. Check your connection and try again.",
      errorEmail: "Please enter a valid email address.",
      errorPhone: "Please enter a valid phone number."
    },
    de: {
      stepLabel: "Letzter Schritt",
      title: "Erhalten Sie Ihre kostenlose Vorschau",
      subtitle: "Geben Sie Ihre Daten ein. Sie erhalten Ihr personalisiertes Lied per E-Mail und SMS innerhalb von 30 Minuten bis 1 Stunde.",
      firstNameLabel: "Ihr Vorname",
      firstNamePlaceholder: "z.B. Thomas",
      lastNameLabel: "Ihr Nachname",
      lastNamePlaceholder: "z.B. Müller",
      emailLabel: "Ihre E-Mail",
      emailPlaceholder: "sie@beispiel.de",
      phoneLabel: "Ihre Telefonnummer",
      phonePlaceholder: "151 23456789",
      countryCodeLabel: "Ländervorwahl",
      ctaSubmit: "Meine kostenlose Vorschau erhalten",
      submittingLabel: "Ihr Lied wird erstellt…",
      consentHint: "Mit dem Absenden dieses Formulars stimmen Sie zu, Ihre Vorschau per E-Mail und SMS zu erhalten. Kein Spam, nur Ihr Lied.",
      successTitle: "Ihre Vorschau wird erstellt",
      successBody: "Sie erhalten Ihr personalisiertes Lied innerhalb von 30 Minuten bis 1 Stunde per <strong>E-Mail</strong> und <strong>SMS</strong>.",
      successHint: "Bitte überprüfen Sie Ihren Spam-Ordner, falls Sie nach 1 Stunde nichts erhalten.",
      errorGeneric: "Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      errorEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      errorPhone: "Bitte geben Sie eine gültige Telefonnummer ein."
    }
  };

  // ============================================================
  //  Country codes — complete worldwide list (ISO 3166-1 alpha-2 + ITU dial code).
  //  Country names are NOT hardcoded — they're resolved at render time via
  //  Intl.DisplayNames in the visitor's own locale (fr/en/de/es). So a FR
  //  visitor sees "Royaume-Uni", an EN visitor sees "United Kingdom", etc.
  //  Use ISO alpha-2 as the value so the webhook payload is locale-stable.
  // ============================================================
  const COUNTRY_CODES = [
    { iso: 'AD', dial: '+376'  }, { iso: 'AE', dial: '+971'  }, { iso: 'AF', dial: '+93'   },
    { iso: 'AG', dial: '+1268' }, { iso: 'AL', dial: '+355'  }, { iso: 'AM', dial: '+374'  },
    { iso: 'AO', dial: '+244'  }, { iso: 'AR', dial: '+54'   }, { iso: 'AT', dial: '+43'   },
    { iso: 'AU', dial: '+61'   }, { iso: 'AZ', dial: '+994'  }, { iso: 'BA', dial: '+387'  },
    { iso: 'BB', dial: '+1246' }, { iso: 'BD', dial: '+880'  }, { iso: 'BE', dial: '+32'   },
    { iso: 'BF', dial: '+226'  }, { iso: 'BG', dial: '+359'  }, { iso: 'BH', dial: '+973'  },
    { iso: 'BI', dial: '+257'  }, { iso: 'BJ', dial: '+229'  }, { iso: 'BN', dial: '+673'  },
    { iso: 'BO', dial: '+591'  }, { iso: 'BR', dial: '+55'   }, { iso: 'BS', dial: '+1242' },
    { iso: 'BT', dial: '+975'  }, { iso: 'BW', dial: '+267'  }, { iso: 'BY', dial: '+375'  },
    { iso: 'BZ', dial: '+501'  }, { iso: 'CA', dial: '+1'    }, { iso: 'CD', dial: '+243'  },
    { iso: 'CF', dial: '+236'  }, { iso: 'CG', dial: '+242'  }, { iso: 'CH', dial: '+41'   },
    { iso: 'CI', dial: '+225'  }, { iso: 'CK', dial: '+682'  }, { iso: 'CL', dial: '+56'   },
    { iso: 'CM', dial: '+237'  }, { iso: 'CN', dial: '+86'   }, { iso: 'CO', dial: '+57'   },
    { iso: 'CR', dial: '+506'  }, { iso: 'CU', dial: '+53'   }, { iso: 'CV', dial: '+238'  },
    { iso: 'CY', dial: '+357'  }, { iso: 'CZ', dial: '+420'  }, { iso: 'DE', dial: '+49'   },
    { iso: 'DJ', dial: '+253'  }, { iso: 'DK', dial: '+45'   }, { iso: 'DM', dial: '+1767' },
    { iso: 'DO', dial: '+1809' }, { iso: 'DZ', dial: '+213'  }, { iso: 'EC', dial: '+593'  },
    { iso: 'EE', dial: '+372'  }, { iso: 'EG', dial: '+20'   }, { iso: 'ER', dial: '+291'  },
    { iso: 'ES', dial: '+34'   }, { iso: 'ET', dial: '+251'  }, { iso: 'FI', dial: '+358'  },
    { iso: 'FJ', dial: '+679'  }, { iso: 'FM', dial: '+691'  }, { iso: 'FO', dial: '+298'  },
    { iso: 'FR', dial: '+33'   }, { iso: 'GA', dial: '+241'  }, { iso: 'GB', dial: '+44'   },
    { iso: 'GD', dial: '+1473' }, { iso: 'GE', dial: '+995'  }, { iso: 'GH', dial: '+233'  },
    { iso: 'GI', dial: '+350'  }, { iso: 'GM', dial: '+220'  }, { iso: 'GN', dial: '+224'  },
    { iso: 'GP', dial: '+590'  }, { iso: 'GQ', dial: '+240'  }, { iso: 'GR', dial: '+30'   },
    { iso: 'GT', dial: '+502'  }, { iso: 'GW', dial: '+245'  }, { iso: 'GY', dial: '+592'  },
    { iso: 'HK', dial: '+852'  }, { iso: 'HN', dial: '+504'  }, { iso: 'HR', dial: '+385'  },
    { iso: 'HT', dial: '+509'  }, { iso: 'HU', dial: '+36'   }, { iso: 'ID', dial: '+62'   },
    { iso: 'IE', dial: '+353'  }, { iso: 'IL', dial: '+972'  }, { iso: 'IN', dial: '+91'   },
    { iso: 'IQ', dial: '+964'  }, { iso: 'IR', dial: '+98'   }, { iso: 'IS', dial: '+354'  },
    { iso: 'IT', dial: '+39'   }, { iso: 'JM', dial: '+1876' }, { iso: 'JO', dial: '+962'  },
    { iso: 'JP', dial: '+81'   }, { iso: 'KE', dial: '+254'  }, { iso: 'KG', dial: '+996'  },
    { iso: 'KH', dial: '+855'  }, { iso: 'KI', dial: '+686'  }, { iso: 'KM', dial: '+269'  },
    { iso: 'KP', dial: '+850'  }, { iso: 'KR', dial: '+82'   }, { iso: 'KW', dial: '+965'  },
    { iso: 'KZ', dial: '+7'    }, { iso: 'LA', dial: '+856'  }, { iso: 'LB', dial: '+961'  },
    { iso: 'LI', dial: '+423'  }, { iso: 'LK', dial: '+94'   }, { iso: 'LR', dial: '+231'  },
    { iso: 'LS', dial: '+266'  }, { iso: 'LT', dial: '+370'  }, { iso: 'LU', dial: '+352'  },
    { iso: 'LV', dial: '+371'  }, { iso: 'LY', dial: '+218'  }, { iso: 'MA', dial: '+212'  },
    { iso: 'MC', dial: '+377'  }, { iso: 'MD', dial: '+373'  }, { iso: 'ME', dial: '+382'  },
    { iso: 'MG', dial: '+261'  }, { iso: 'MH', dial: '+692'  }, { iso: 'MK', dial: '+389'  },
    { iso: 'ML', dial: '+223'  }, { iso: 'MM', dial: '+95'   }, { iso: 'MN', dial: '+976'  },
    { iso: 'MO', dial: '+853'  }, { iso: 'MQ', dial: '+596'  }, { iso: 'MR', dial: '+222'  },
    { iso: 'MT', dial: '+356'  }, { iso: 'MU', dial: '+230'  }, { iso: 'MV', dial: '+960'  },
    { iso: 'MW', dial: '+265'  }, { iso: 'MX', dial: '+52'   }, { iso: 'MY', dial: '+60'   },
    { iso: 'MZ', dial: '+258'  }, { iso: 'NA', dial: '+264'  }, { iso: 'NC', dial: '+687'  },
    { iso: 'NE', dial: '+227'  }, { iso: 'NG', dial: '+234'  }, { iso: 'NI', dial: '+505'  },
    { iso: 'NL', dial: '+31'   }, { iso: 'NO', dial: '+47'   }, { iso: 'NP', dial: '+977'  },
    { iso: 'NR', dial: '+674'  }, { iso: 'NZ', dial: '+64'   }, { iso: 'OM', dial: '+968'  },
    { iso: 'PA', dial: '+507'  }, { iso: 'PE', dial: '+51'   }, { iso: 'PF', dial: '+689'  },
    { iso: 'PG', dial: '+675'  }, { iso: 'PH', dial: '+63'   }, { iso: 'PK', dial: '+92'   },
    { iso: 'PL', dial: '+48'   }, { iso: 'PR', dial: '+1'    }, { iso: 'PS', dial: '+970'  },
    { iso: 'PT', dial: '+351'  }, { iso: 'PW', dial: '+680'  }, { iso: 'PY', dial: '+595'  },
    { iso: 'QA', dial: '+974'  }, { iso: 'RE', dial: '+262'  }, { iso: 'RO', dial: '+40'   },
    { iso: 'RS', dial: '+381'  }, { iso: 'RU', dial: '+7'    }, { iso: 'RW', dial: '+250'  },
    { iso: 'SA', dial: '+966'  }, { iso: 'SB', dial: '+677'  }, { iso: 'SC', dial: '+248'  },
    { iso: 'SD', dial: '+249'  }, { iso: 'SE', dial: '+46'   }, { iso: 'SG', dial: '+65'   },
    { iso: 'SI', dial: '+386'  }, { iso: 'SK', dial: '+421'  }, { iso: 'SL', dial: '+232'  },
    { iso: 'SM', dial: '+378'  }, { iso: 'SN', dial: '+221'  }, { iso: 'SO', dial: '+252'  },
    { iso: 'SR', dial: '+597'  }, { iso: 'SS', dial: '+211'  }, { iso: 'ST', dial: '+239'  },
    { iso: 'SV', dial: '+503'  }, { iso: 'SY', dial: '+963'  }, { iso: 'SZ', dial: '+268'  },
    { iso: 'TD', dial: '+235'  }, { iso: 'TG', dial: '+228'  }, { iso: 'TH', dial: '+66'   },
    { iso: 'TJ', dial: '+992'  }, { iso: 'TL', dial: '+670'  }, { iso: 'TM', dial: '+993'  },
    { iso: 'TN', dial: '+216'  }, { iso: 'TO', dial: '+676'  }, { iso: 'TR', dial: '+90'   },
    { iso: 'TT', dial: '+1868' }, { iso: 'TV', dial: '+688'  }, { iso: 'TW', dial: '+886'  },
    { iso: 'TZ', dial: '+255'  }, { iso: 'UA', dial: '+380'  }, { iso: 'UG', dial: '+256'  },
    { iso: 'US', dial: '+1'    }, { iso: 'UY', dial: '+598'  }, { iso: 'UZ', dial: '+998'  },
    { iso: 'VA', dial: '+39'   }, { iso: 'VE', dial: '+58'   }, { iso: 'VN', dial: '+84'   },
    { iso: 'VU', dial: '+678'  }, { iso: 'WS', dial: '+685'  }, { iso: 'YE', dial: '+967'  },
    { iso: 'ZA', dial: '+27'   }, { iso: 'ZM', dial: '+260'  }, { iso: 'ZW', dial: '+263'  }
  ];

  /** Localize a list of country codes for the given locale using Intl.DisplayNames.
   *  Falls back to the bare ISO code if the API isn't supported (very old browsers). */
  function localizedCountries(locale) {
    let translator = null;
    try { translator = new Intl.DisplayNames([locale], { type: 'region' }); } catch (e) {}
    return COUNTRY_CODES
      .map(cc => ({
        iso: cc.iso,
        dial: cc.dial,
        name: (translator && translator.of(cc.iso)) || cc.iso
      }))
      .sort((a, b) => a.name.localeCompare(b.name, locale));
  }

  /** Map locale → default country ISO (selected in the dropdown on first render). */
  function defaultCountryForLocale(locale) {
    if (locale.startsWith('de')) return 'DE';
    if (locale.startsWith('es')) return 'ES';
    if (locale.startsWith('en')) return 'GB';
    return 'FR';
  }

  // Countries whose carriers require a separate, explicit SMS opt-in checkbox +
  // the standardized disclaimer (US TCR / toll-free verification, Canada CWTA).
  const SMS_STRICT_OPTIN_ISOS = ['US', 'CA'];

  // Compliance markup shown ONLY when US or CA is selected as the phone country.
  // Wording mandated by the US toll-free / 10DLC verification process.
  // Kept in English (compliance language the carriers/reviewers expect).
  const US_SMS_CONSENT_HTML = `
    <div class="ym-quiz__sms-consent" data-ym="sms-consent" hidden>
      <label class="ym-quiz__sms-consent-row">
        <input type="checkbox" data-ym-field="smsConsent">
        <span>I agree to receive automated text messages from YourMelody at the phone number provided.</span>
      </label>
      <p class="ym-quiz__sms-disclaimer">Message frequency may vary. Standard message and data rates may apply. Reply STOP to opt out. Reply HELP for assistance. Your mobile information will not be sold or shared with third parties for promotional or marketing purposes.</p>
    </div>`;

  const RECIPIENT_KEYS = [
    'husband','wife','child','mother','father',
    'girlfriend','boyfriend','sibling','friend','self','other'
  ];

  function emptyAnswers() {
    return {
      recipient: null,
      recipientOther: '',
      recipientName: '',
      musicStyle: null,
      musicStyleOther: '',
      voice: null,
      occasion: null,
      occasionOther: '',
      qualities: '',
      memories: '',
      difficulties: '',
      message: '',
      // Flat keys = play nice with the generic data-ym-field text-input binder
      leadFirstName: '',
      leadLastName: '',
      leadEmail: '',
      leadPhone: '',
      leadCountryIso: '',  // Filled at first render from the user's locale (FR/DE/GB/...)
      smsConsent: false    // US/CA only: explicit SMS opt-in checkbox (TCR compliance)
    };
  }

  /** Lightweight client-side validators — server (Make) re-validates. */
  function isValidEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((s || '').trim());
  }
  /** Returns only the digits in the string. Used to clean the local phone number. */
  function digitsOnly(s) {
    return (s || '').replace(/\D+/g, '');
  }
  /** Local part of the phone must have 6–12 digits. Country code is separate. */
  function isValidLocalPhone(s) {
    const d = digitsOnly(s);
    return d.length >= 6 && d.length <= 12;
  }
  /** Normalize a local number to E.164 by combining with the dial code and stripping a leading 0.
   *  Example: dial='+33', local='06 12 34 56 78' → '+33612345678'. */
  function toE164(dialCode, localPhone) {
    let local = digitsOnly(localPhone);
    // Strip leading 0 if present (FR/BE/DE/... national prefix) — only when dial code is not +1 (NANP includes leading area-code digit).
    if (dialCode !== '+1' && local.startsWith('0')) {
      local = local.replace(/^0+/, '');
    }
    return dialCode + local;
  }

  /** Generate a short UUID-ish token for this lead session — used to correlate
   *  the preview URL we send by email/SMS later. */
  function genToken() {
    return ('p_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10));
  }

  /** HTML-escape user-controlled strings before inserting into innerHTML. */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /** Robust "is this an 'Other' option?" check across FR/EN/DE. */
  function isOtherValue(v) {
    return !!v && /\b(autre|other|andere|précisez|specify|unten)\b/i.test(v);
  }

  class YMQuiz {
    constructor(root) {
      this.root = root;
      this.locale = (root.dataset.locale || 'fr').toLowerCase();
      // Normalize locale to one of fr/en/de for list lookups
      this.listLocale = this.locale.startsWith('en') ? 'en'
                      : this.locale.startsWith('de') ? 'de' : 'fr';
      this.webhookUrl = root.dataset.webhookUrl || '';
      this.successUrl = root.dataset.successUrl || '';
      this.currentStep = STEPS[0];
      this.answers = emptyAnswers();
      this.answers.leadCountryIso = defaultCountryForLocale(this.locale);
      this.token = genToken();

      // Track which steps have been "arrived on" this session
      this.trackedSteps = new Set();

      this.els = {
        progress: root.querySelector('.ym-quiz__progress'),
        stepLabel: root.querySelector('[data-ym="step-label"]'),
        stepTitle: root.querySelector('[data-ym="step-title"]'),
        stepSubtitle: root.querySelector('[data-ym="step-subtitle"]'),
        stepContent: root.querySelector('[data-ym="step-content"]'),
        btnBack: root.querySelector('[data-ym="back"]'),
        btnNext: root.querySelector('[data-ym="next"]')
      };
    }

    save() {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
          v: 1, lastUpdated: Date.now(), locale: this.locale,
          step: this.currentStep, answers: this.answers, token: this.token
        }));
      } catch (e) {}
    }
    load() {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const data = JSON.parse(raw);
        if (data.v !== 1) return false;
        if (Date.now() - (data.lastUpdated || 0) > STATE_TTL_MS) return false;
        this.answers = Object.assign(emptyAnswers(), data.answers || {});
        if (!this.answers.leadCountryIso) {
          this.answers.leadCountryIso = defaultCountryForLocale(this.locale);
        }
        if (data.token) this.token = data.token;
        this.currentStep = STEPS.includes(data.step) ? data.step : STEPS[0];
        return true;
      } catch (e) { return false; }
    }
    clear() {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      this.answers = emptyAnswers();
      this.token = genToken();
      this.currentStep = STEPS[0];
    }
    stepIndex() { return STEPS.indexOf(this.currentStep); }

    /** Fire a tracking event to fbq + dataLayer. Errors are swallowed (adblockers etc.). */
    track(eventName, payload) {
      const data = Object.assign({ locale: this.locale, step: this.currentStep }, payload || {});
      try { if (window.fbq) window.fbq('trackCustom', eventName, data); } catch (e) {}
      try { if (window.gtag) window.gtag('event', eventName, data); } catch (e) {}
      try {
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push(Object.assign({ event: 'ym_' + eventName.toLowerCase() }, data));
        }
      } catch (e) {}
    }

    /** Fire arrival event for a step. Each step fires at most once per session
     *  (so back/forward doesn't double-count and skew the funnel). */
    trackArrival(step) {
      if (this.trackedSteps.has(step)) return;
      this.trackedSteps.add(step);
      const eventMap = {
        'step-1':       'LeadQuizStarted',
        'step-2':       'LeadQuizStep2',
        'step-3':       'LeadQuizStep3',
        'step-4':       'LeadQuizStep4',
        'step-5':       'LeadQuizStep5',
        'step-6':       'LeadQuizStep6',
        'step-7':       'LeadQuizStep7',
        'lead-capture': 'LeadCaptureView'
      };
      if (eventMap[step]) this.track(eventMap[step]);
    }

    goto(step, opts) {
      if (!STEPS.includes(step)) return;
      this.currentStep = step;
      this.save();
      this.render();
      if (!opts || !opts.silent) {
        const hash = '#' + step;
        if (window.location.hash !== hash) window.location.hash = hash;
      }
      // Scroll the quiz section to the top of the viewport so the new step is visible
      this.scrollToQuizTop();
      this.trackArrival(step);
    }

    /** Scroll viewport so the quiz progress bar is just below the site header.
     *  Respects prefers-reduced-motion. */
    scrollToQuizTop() {
      const anchor = this.els.progress || this.root;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      // Aim for the anchor to be ~24px from the top of the viewport (leaves a little breathing room)
      const targetY = window.pageYOffset + rect.top - 24;
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        window.scrollTo({ top: Math.max(0, targetY), behavior: reducedMotion ? 'auto' : 'smooth' });
      } catch (e) {
        // Older browsers without scroll options
        window.scrollTo(0, Math.max(0, targetY));
      }
    }
    next() {
      const i = this.stepIndex();
      if (i < STEPS.length - 1) {
        this.goto(STEPS[i + 1]);
      } else {
        this.submit();
      }
    }
    back() {
      const i = this.stepIndex();
      if (i > 0) this.goto(STEPS[i - 1]);
    }

    // ============================================================
    //  Render
    // ============================================================
    render() {
      const i = this.stepIndex();

      // Progress dots
      if (this.els.progress) {
        Array.from(this.els.progress.children).forEach((dot, idx) => {
          dot.className = 'ym-quiz__progress-dot';
          if (idx < i) dot.classList.add('ym-quiz__progress-dot--done');
          if (idx === i) dot.classList.add('ym-quiz__progress-dot--active');
        });
      }

      // Back hidden on Step 1 only
      this.els.btnBack.hidden = (i === 0);

      // Next label
      const copy = LEAD_COPY[this.listLocale] || LEAD_COPY.fr;
      const nextLabel = this.els.btnNext.querySelector('span:not([aria-hidden])');
      if (nextLabel) {
        nextLabel.textContent = (i === STEPS.length - 1)
          ? copy.ctaSubmit
          : window.__ymI18n('quiz.buttons.next', 'Continuer');
      }

      // Step label (top)
      if (i < 7) {
        const tpl = window.__ymI18n('quiz.labels.step_of', 'Étape {{ current }} sur 7');
        this.els.stepLabel.textContent = tpl.replace('{{ current }}', String(i + 1));
      } else {
        // lead-capture
        this.els.stepLabel.textContent = copy.stepLabel;
      }

      // Title + subtitle
      if (this.currentStep === 'lead-capture') {
        this.els.stepTitle.textContent = copy.title;
        this.els.stepSubtitle.textContent = copy.subtitle;
      } else {
        const stepKey = this.currentStep.replace('-', '');
        this.els.stepTitle.textContent = window.__ymI18n('quiz.' + stepKey + '.title', '');
        this.els.stepSubtitle.textContent = window.__ymI18n('quiz.' + stepKey + '.subtitle', '');
      }

      // Body
      this.renderStepBody();
      this.updateNextEnabled();
    }

    renderStepBody() {
      this.els.stepContent.innerHTML = this.stepBodyHTML(this.currentStep);
      this.bindStepBody();
      this.restoreStepValues();
    }

    /** Renders the urgency widget content (2 sessions with progress bars).
     *  Each row shows only the DELIVERY date (the recording date is implicit). */

    /** Build the HTML for the current step's content area. */
    stepBodyHTML(step) {
      const t = (k, d) => window.__ymI18n(k, d);
      const lists = LISTS[this.listLocale] || LISTS.fr;

      if (step === 'step-1') {
        const recipients = window.__ymTree('step1.recipients') || {};
        const pills = RECIPIENT_KEYS
          .map(k => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(k)}" data-ym-field="recipient">${esc(recipients[k] || k)}</button>`)
          .join('');
        return `
          <div class="ym-quiz__pills" data-ym-pill-group="recipient">${pills}</div>
          <div class="ym-quiz__other-reveal" data-ym-other-for="recipient" hidden>
            <p class="ym-quiz__field-label">${esc(t('quiz.step1.other_label','Précisez la relation'))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="recipientOther" placeholder="${esc(t('quiz.step1.other_placeholder','Ex. Mon parrain, ma belle-mère…'))}" maxlength="60">
          </div>
          <div>
            <p class="ym-quiz__field-label">${esc(t('quiz.step1.name_label','Son prénom'))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="recipientName" placeholder="${esc(t('quiz.step1.name_placeholder','Ex. Sophie'))}" maxlength="40">
          </div>`;
      }

      if (step === 'step-2') {
        const stylePills = lists.styles
          .map(s => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(s)}" data-ym-field="musicStyle">${esc(s)}</button>`)
          .join('');
        const voicePills = lists.voices
          .map(v => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(v)}" data-ym-field="voice">${esc(v)}</button>`)
          .join('');
        return `
          <p class="ym-quiz__field-label">${esc(t('quiz.step2.styles_label','Style'))}</p>
          <div class="ym-quiz__pills" data-ym-pill-group="musicStyle">${stylePills}</div>
          <div class="ym-quiz__other-reveal" data-ym-other-for="musicStyle" hidden>
            <p class="ym-quiz__field-label">${esc(t('quiz.step2.other_label','Précisez le style souhaité'))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="musicStyleOther" placeholder="${esc(t('quiz.step2.other_placeholder',''))}" maxlength="80">
          </div>
          <div>
            <p class="ym-quiz__field-label">${esc(t('quiz.step2.voice_label','Voix'))}</p>
            <div class="ym-quiz__pills" data-ym-pill-group="voice">${voicePills}</div>
          </div>`;
      }

      if (step === 'step-3') {
        const pills = lists.occasions
          .map(o => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(o)}" data-ym-field="occasion">${esc(o)}</button>`)
          .join('');
        return `
          <div class="ym-quiz__pills" data-ym-pill-group="occasion">${pills}</div>
          <div class="ym-quiz__other-reveal" data-ym-other-for="occasion" hidden>
            <p class="ym-quiz__field-label">${esc(t('quiz.step3.other_label',"Précisez l'occasion"))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="occasionOther" placeholder="${esc(t('quiz.step3.other_placeholder',''))}" maxlength="80">
          </div>`;
      }

      // Steps 4-7: textarea
      const textareaSteps = {
        'step-4': { field: 'qualities', labelKey: 'quiz.step4.field_label', phKey: 'quiz.step4.placeholder' },
        'step-5': { field: 'memories',  labelKey: 'quiz.step5.field_label', phKey: 'quiz.step5.placeholder' },
        'step-6': { field: 'difficulties', labelKey: 'quiz.step6.field_label', phKey: 'quiz.step6.placeholder' },
        'step-7': { field: 'message',   labelKey: 'quiz.step7.field_label', phKey: 'quiz.step7.placeholder' }
      };
      if (textareaSteps[step]) {
        const cfg = textareaSteps[step];
        return `
          <p class="ym-quiz__field-label">${esc(t(cfg.labelKey,''))}</p>
          <div class="ym-quiz__textarea-wrap">
            <textarea class="ym-quiz__textarea" data-ym-field="${cfg.field}" placeholder="${esc(t(cfg.phKey,''))}" rows="6"></textarea>
          </div>`;
      }

      if (step === 'lead-capture') {
        const c = LEAD_COPY[this.listLocale] || LEAD_COPY.fr;
        const selectedIso = this.answers.leadCountryIso || defaultCountryForLocale(this.locale);
        // Country names are translated at render time into the visitor's locale.
        // Name-first label so the browser's type-to-search jumps to the right country.
        const countryOptions = localizedCountries(this.locale)
          .map(cc => `<option value="${esc(cc.iso)}"${cc.iso === selectedIso ? ' selected' : ''}>${esc(cc.name)} · ${esc(cc.dial)}</option>`)
          .join('');
        return `
          <div class="ym-quiz__lead-grid">
            <div class="ym-quiz__lead-field">
              <label class="ym-quiz__field-label" for="ym-lead-firstname">${esc(c.firstNameLabel)} <span class="ym-quiz__req">*</span></label>
              <input id="ym-lead-firstname" type="text" class="ym-quiz__text-input" data-ym-field="leadFirstName" placeholder="${esc(c.firstNamePlaceholder)}" autocomplete="given-name" maxlength="60">
            </div>
            <div class="ym-quiz__lead-field">
              <label class="ym-quiz__field-label" for="ym-lead-lastname">${esc(c.lastNameLabel)} <span class="ym-quiz__req">*</span></label>
              <input id="ym-lead-lastname" type="text" class="ym-quiz__text-input" data-ym-field="leadLastName" placeholder="${esc(c.lastNamePlaceholder)}" autocomplete="family-name" maxlength="60">
            </div>
            <div class="ym-quiz__lead-field ym-quiz__lead-field--full">
              <label class="ym-quiz__field-label" for="ym-lead-email">${esc(c.emailLabel)} <span class="ym-quiz__req">*</span></label>
              <input id="ym-lead-email" type="email" class="ym-quiz__text-input" data-ym-field="leadEmail" placeholder="${esc(c.emailPlaceholder)}" autocomplete="email" inputmode="email" maxlength="120">
              <p class="ym-quiz__field-error" data-ym="lead-email-error" hidden></p>
            </div>
            <div class="ym-quiz__lead-field ym-quiz__lead-field--full">
              <label class="ym-quiz__field-label">${esc(c.phoneLabel)} <span class="ym-quiz__req">*</span></label>
              <div class="ym-quiz__phone-row">
                <select class="ym-quiz__phone-cc" data-ym-field="leadCountryIso" aria-label="${esc(c.countryCodeLabel)}" required>
                  ${countryOptions}
                </select>
                <input id="ym-lead-phone" type="tel" class="ym-quiz__text-input ym-quiz__phone-input" data-ym-field="leadPhone" placeholder="${esc(c.phonePlaceholder)}" autocomplete="tel" inputmode="tel" maxlength="20">
              </div>
              <p class="ym-quiz__field-error" data-ym="lead-phone-error" hidden></p>
            </div>
            <p class="ym-quiz__consent-hint">${esc(c.consentHint)}</p>
            ${US_SMS_CONSENT_HTML}
          </div>`;
      }

      return `<p style="text-align:center;color:#888;padding:40px 0;">${esc(step)}</p>`;
    }

    /** Bind input/click events for the just-rendered step body. */
    bindStepBody() {
      const root = this.els.stepContent;
      // Pills
      root.querySelectorAll('.ym-quiz__pill').forEach(btn => {
        btn.addEventListener('click', () => {
          const field = btn.dataset.ymField;
          const value = btn.dataset.ymPill;
          const group = btn.closest('.ym-quiz__pills');
          if (group) {
            group.querySelectorAll('.ym-quiz__pill').forEach(b => b.setAttribute('aria-pressed', 'false'));
            btn.setAttribute('aria-pressed', 'true');
          }
          this.answers[field] = value;
          // Reveal/hide "Other" text input
          const other = root.querySelector('[data-ym-other-for="' + field + '"]');
          if (other) other.hidden = !isOtherValue(value);
          this.save();
          this.updateNextEnabled();
        });
      });
      // Text inputs + textareas (generic — handles all data-ym-field except checkboxes)
      root.querySelectorAll('[data-ym-field]:not(.ym-quiz__pill)').forEach(el => {
        const field = el.dataset.ymField;
        if (field === 'smsConsent') return; // checkbox, handled separately below
        el.addEventListener('input', () => {
          this.answers[field] = el.value;
          this.save();
          this.updateNextEnabled();
          // Live-clear lead-capture validation errors as the user fixes them
          if (field === 'leadEmail' || field === 'leadPhone') {
            const errId = field === 'leadEmail' ? 'lead-email-error' : 'lead-phone-error';
            const errEl = root.querySelector('[data-ym="' + errId + '"]');
            if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
          }
          // Selecting US/CA reveals the compliance SMS opt-in block.
          if (field === 'leadCountryIso') this.updateUSConsentVisibility();
        });
      });

      // Lead-capture specifics: country <select> change + SMS consent checkbox.
      if (this.currentStep === 'lead-capture') {
        const ccSelect = root.querySelector('[data-ym-field="leadCountryIso"]');
        if (ccSelect) {
          ccSelect.addEventListener('change', () => {
            this.answers.leadCountryIso = ccSelect.value;
            this.save();
            this.updateUSConsentVisibility();
          });
        }
        const smsCb = root.querySelector('[data-ym-field="smsConsent"]');
        if (smsCb) {
          smsCb.addEventListener('change', () => {
            this.answers.smsConsent = smsCb.checked;
            this.save();
          });
        }
      }
    }

    /** Show the US/CA SMS opt-in compliance block only when one of those countries
     *  is selected. Required for US toll-free / 10DLC carrier verification. */
    updateUSConsentVisibility() {
      const box = this.els.stepContent.querySelector('[data-ym="sms-consent"]');
      if (!box) return;
      const iso = (this.answers.leadCountryIso || '').toUpperCase();
      box.hidden = SMS_STRICT_OPTIN_ISOS.indexOf(iso) === -1;
    }

    restoreStepValues() {
      const root = this.els.stepContent;
      root.querySelectorAll('.ym-quiz__pill').forEach(btn => {
        const field = btn.dataset.ymField;
        const value = btn.dataset.ymPill;
        if (this.answers[field] === value) {
          btn.setAttribute('aria-pressed', 'true');
          if (isOtherValue(value)) {
            const other = root.querySelector('[data-ym-other-for="' + field + '"]');
            if (other) other.hidden = false;
          }
        }
      });
      root.querySelectorAll('[data-ym-field]:not(.ym-quiz__pill)').forEach(el => {
        const field = el.dataset.ymField;
        if (field === 'smsConsent') { el.checked = !!this.answers.smsConsent; return; }
        const v = this.answers[field];
        if (v != null) el.value = v;
      });
      // Reveal the US/CA SMS consent block if the restored country requires it.
      if (this.currentStep === 'lead-capture') this.updateUSConsentVisibility();
    }

    updateNextEnabled() {
      let ok = true;
      const a = this.answers;
      switch (this.currentStep) {
        case 'step-1':
          ok = !!a.recipient && !!a.recipientName && a.recipientName.trim().length > 0;
          if (ok && a.recipient === 'other') {
            ok = !!a.recipientOther && a.recipientOther.trim().length > 0;
          }
          break;
        case 'step-2':
          ok = !!a.musicStyle && !!a.voice;
          if (ok && isOtherValue(a.musicStyle)) {
            ok = !!a.musicStyleOther && a.musicStyleOther.trim().length > 0;
          }
          break;
        case 'step-3':
          ok = !!a.occasion;
          if (ok && isOtherValue(a.occasion)) {
            ok = !!a.occasionOther && a.occasionOther.trim().length > 0;
          }
          break;
        case 'step-4':
        case 'step-5':
        case 'step-6':
        case 'step-7':
          ok = true;
          break;
        case 'lead-capture': {
          const fn = (a.leadFirstName || '').trim();
          const ln = (a.leadLastName || '').trim();
          const em = (a.leadEmail || '').trim();
          const ph = (a.leadPhone || '').trim();
          const cc = (a.leadCountryIso || '').trim();
          // Format validation runs at submit-time; here we just gate on non-empty.
          ok = fn.length > 0 && ln.length > 0 && em.length > 0 && ph.length > 0 && cc.length > 0;
          break;
        }
        default:
          ok = true;
      }
      this.els.btnNext.disabled = !ok;
    }

    // ============================================================
    //  Cart submission (Phase 9)
    // ============================================================

    /** Resolve recipient slug → localized label, with "Autre" override. */
    resolveRecipient() {
      const a = this.answers;
      if (a.recipient === 'other') {
        return (a.recipientOther || '').trim() || 'Autre';
      }
      const recipients = window.__ymTree('step1.recipients') || {};
      return recipients[a.recipient] || a.recipient || '';
    }

    /** Resolve style/occasion with "Autre" override. */
    resolveWithOther(value, otherText) {
      if (!value) return '';
      if (isOtherValue(value)) return (otherText || '').trim() || value;
      return value;
    }

    /** Flatten user free-text for safe re-use inside any downstream JSON
     *  template (Make.com → OpenAI / Suno request body). We keep the meaning,
     *  lose nothing essential for lyric generation, and avoid JSON-escaping hell
     *  in Make where the body is assembled as a raw string (no auto-escaping).
     *  A single stray backslash or double-quote in a name/message is enough to
     *  break the Suno POST body ("Expected ',' or '}' ... at position N") and the
     *  Break-retry can't fix it — it replays the same poisoned text. So we drop
     *  the two characters that escape/terminate a JSON string literal (backslash
     *  and double-quote) and collapse line breaks, before the value leaves the
     *  browser. Whitespace control chars are folded to spaces by the \s+ pass. */
    flatten(s) {
      return String(s == null ? '' : s)
        .replace(/[\r\n]+/g, '. ')          // any line break → period+space
        .replace(/\s+/g, ' ')               // collapse runs of whitespace
        .replace(/\\/g, '')                 // drop backslashes (would escape the next char → broken JSON)
        .replace(/"/g, "'")                 // double quotes → single (safe inside JSON literals)
        .trim();
    }

    /** Assemble the JSON payload posted to the Make.com webhook.
     *  Keys are kept in English so the Make scenario doesn't have to handle 4 locales. */
    buildLeadPayload() {
      const a = this.answers;
      const iso = a.leadCountryIso || defaultCountryForLocale(this.locale);
      const cc  = COUNTRY_CODES.find(c => c.iso === iso) || COUNTRY_CODES[0];
      const phoneE164 = toE164(cc.dial, a.leadPhone);
      // Shared eventId between the client-side pixel call and the server-side
      // Conversions API call from Make → lets Meta deduplicate the Lead event.
      const eventId = this.lastEventId || ('lead_' + this.token);
      this.lastEventId = eventId;
      return {
        token: this.token,
        eventId: eventId,
        locale: this.locale,
        submittedAt: new Date().toISOString(),
        source: 'free-preview-quiz',
        url: (window && window.location && window.location.href) || '',
        userAgent: (navigator && navigator.userAgent) || '',
        lead: {
          firstName: this.flatten(a.leadFirstName),   // flatten() also strips \ and " (JSON-safe)
          lastName:  this.flatten(a.leadLastName),
          email:     (a.leadEmail || '').trim().toLowerCase(),
          phone:     phoneE164,            // E.164 format, e.g. "+33612345678"
          phoneLocal: (a.leadPhone || '').trim(),  // what the user typed (debug/reference)
          countryIso: iso,                 // "FR", "DE", "US", ...
          countryDial: cc.dial,            // "+33", "+49", "+1", ...
          // US/CA explicit SMS opt-in. For other countries SMS consent is implied
          // by the form submission; this flag is only meaningful for US/CA gating.
          smsConsent: (SMS_STRICT_OPTIN_ISOS.indexOf(iso) === -1) ? true : !!a.smsConsent
        },
        song: {
          recipientKey:    a.recipient || '',
          recipientLabel:  this.flatten(this.resolveRecipient()),
          recipientOther:  this.flatten(a.recipientOther),
          recipientName:   this.flatten(a.recipientName),
          musicStyle:      this.flatten(this.resolveWithOther(a.musicStyle, a.musicStyleOther)),
          musicStyleOther: this.flatten(a.musicStyleOther),
          voice:           this.flatten(a.voice),
          occasion:        this.flatten(this.resolveWithOther(a.occasion, a.occasionOther)),
          occasionOther:   this.flatten(a.occasionOther),
          qualities:       this.flatten(a.qualities),
          memories:        this.flatten(a.memories),
          difficulties:    this.flatten(a.difficulties),
          message:         this.flatten(a.message)
        }
      };
    }

    /** Display an error message under the button row. Creates the element if missing. */
    showSubmitError(message) {
      const btnRow = this.root.querySelector('.ym-quiz__button-row');
      if (!btnRow) return;
      let err = this.root.querySelector('[data-ym="submit-error"]');
      if (!err) {
        err = document.createElement('p');
        err.setAttribute('data-ym', 'submit-error');
        err.className = 'ym-quiz__submit-error';
        btnRow.parentElement.insertBefore(err, btnRow.nextSibling);
      }
      err.textContent = message;
      err.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    clearSubmitError() {
      const err = this.root.querySelector('[data-ym="submit-error"]');
      if (err) err.remove();
    }

    /** Fire the Lead conversion events to Meta Pixel + GA4 + GTM dataLayer.
     *  Called once after the webhook POST succeeds. Errors are swallowed so a
     *  blocked pixel/adblocker never prevents the success UI. */
    fireLeadConversionEvents(payload) {
      const lead = payload.lead || {};
      const eventId = payload.eventId;

      // ---- Meta Pixel: standard "Lead" event ---------------------------------
      // Advanced Matching: include hashable PII so Meta can match the user even
      // when third-party cookies are blocked. The pixel hashes these client-side.
      try {
        if (typeof window.fbq === 'function') {
          window.fbq(
            'track',
            'Lead',
            {
              content_name: 'YourMelody Free Preview',
              content_category: 'free-song-quiz',
              currency: 'EUR',
              value: 0.00,
              // Advanced Matching fields (Meta auto-hashes these)
              em: (lead.email || '').toLowerCase().trim(),
              ph: (lead.phone || '').replace(/^\+/, ''), // E.164 without "+"
              fn: (lead.firstName || '').toLowerCase().trim(),
              ln: (lead.lastName || '').toLowerCase().trim(),
              country: (lead.countryIso || '').toLowerCase()
            },
            { eventID: eventId }   // for dedupe with Conversions API in Make
          );
        }
      } catch (e) { console.warn('[ym-quiz-lead] fbq Lead failed', e); }

      // ---- Google Analytics 4 / Google Ads (gtag.js) -------------------------
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', {
            currency: 'EUR',
            value: 0.00,
            event_id: eventId,
            method: 'free-preview-quiz'
          });
        }
      } catch (e) { console.warn('[ym-quiz-lead] gtag generate_lead failed', e); }

      // ---- GTM dataLayer (consumed by any tag manager) -----------------------
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: 'generate_lead',
            event_id: eventId,
            lead_token: payload.token,
            lead_source: payload.source,
            lead_locale: payload.locale,
            lead_country: lead.countryIso,
            lead_email: lead.email,         // GTM can hash before forwarding
            lead_phone: lead.phone,
            lead_first_name: lead.firstName,
            lead_last_name: lead.lastName,
            currency: 'EUR',
            value: 0.00
          });
        }
      } catch (e) { console.warn('[ym-quiz-lead] dataLayer push failed', e); }
    }

    /** Show the success screen and hide the quiz UI.
     *  Uses a state class on the root (force-overrides flex layouts via !important).
     *  Why not `hidden`? — `.ym-quiz__button-row { display:flex }` beats `[hidden]`
     *  on specificity and the CTA spinner would stay visible forever. */
    showSuccess() {
      const c = LEAD_COPY[this.listLocale] || LEAD_COPY.fr;
      const successEl = this.root.querySelector('[data-ym="success"]');
      if (successEl) {
        const titleEl = successEl.querySelector('[data-ym="success-title"]');
        const bodyEl  = successEl.querySelector('[data-ym="success-body"]');
        const hintEl  = successEl.querySelector('[data-ym="success-hint"]');
        if (titleEl) titleEl.textContent = c.successTitle;
        if (bodyEl)  bodyEl.innerHTML    = c.successBody; // contains <strong>
        if (hintEl)  hintEl.textContent  = c.successHint;
        successEl.hidden = false;
      }
      // State class drives CSS that hides every other quiz element with !important.
      this.root.classList.add('ym-quiz--submitted');
      // Belt-and-suspenders: also remove any submit-error left over from a previous failed attempt.
      this.clearSubmitError();
      // Scroll the success card into view (top-aligned so the icon is the first thing seen)
      if (successEl) successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /** POST the full quiz + lead data to the Make webhook. */
    async submit() {
      const a = this.answers;
      const c = LEAD_COPY[this.listLocale] || LEAD_COPY.fr;
      const root = this.els.stepContent;

      // 1. Final-form validation (email + phone format)
      const emailErrEl = root.querySelector('[data-ym="lead-email-error"]');
      const phoneErrEl = root.querySelector('[data-ym="lead-phone-error"]');
      let validationOK = true;
      if (!isValidEmail(a.leadEmail)) {
        if (emailErrEl) { emailErrEl.textContent = c.errorEmail; emailErrEl.hidden = false; }
        validationOK = false;
      }
      if (!isValidLocalPhone(a.leadPhone)) {
        if (phoneErrEl) { phoneErrEl.textContent = c.errorPhone; phoneErrEl.hidden = false; }
        validationOK = false;
      }
      if (!validationOK) return;

      // 2. Webhook URL sanity check
      if (!this.webhookUrl) {
        this.showSubmitError('Webhook URL not configured (section settings).');
        return;
      }

      const btnNext = this.els.btnNext;
      const labelEl = btnNext.querySelector('span:not([aria-hidden])');
      const originalLabel = labelEl ? labelEl.textContent : '';
      btnNext.disabled = true;
      btnNext.classList.add('ym-quiz__btn--loading');
      if (labelEl) labelEl.textContent = c.submittingLabel;
      this.clearSubmitError();

      try {
        const payload = this.buildLeadPayload();
        const resp = await fetch(this.webhookUrl, {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!resp.ok) {
          const text = await resp.text();
          throw new Error('Webhook failed (' + resp.status + '): ' + text.slice(0, 200));
        }

        // Fire Meta Pixel `Lead` + GA4 `generate_lead` + GTM dataLayer events.
        // Same eventId is in the webhook payload → Make can call Conversions API
        // server-side with the same eventId for dedupe.
        this.fireLeadConversionEvents(payload);

        // 3. Clear local state, show success screen
        this.clear();
        this.showSuccess();

        // 4. Optional redirect after 2s
        if (this.successUrl) {
          setTimeout(() => { window.location.href = this.successUrl; }, 2000);
        }
      } catch (err) {
        console.error('[ym-quiz-lead] submit error', err);
        btnNext.disabled = false;
        btnNext.classList.remove('ym-quiz__btn--loading');
        if (labelEl) labelEl.textContent = originalLabel;
        const detail = (err && err.message) ? '\n(' + err.message + ')' : '';
        this.showSubmitError(c.errorGeneric + detail);
      }
    }

    bind() {
      this.els.btnBack.addEventListener('click', () => this.back());
      this.els.btnNext.addEventListener('click', () => this.next());
      window.addEventListener('hashchange', () => {
        const target = window.location.hash.slice(1);
        if (STEPS.includes(target) && target !== this.currentStep) {
          this.goto(target, { silent: true });
        }
      });
    }

    start() {
      this.load();
      const hashStep = window.location.hash.slice(1);
      if (STEPS.includes(hashStep)) this.currentStep = hashStep;
      this.bind();
      this.render();
      // Fire arrival event for the initial step (fresh visit OR resumed session)
      this.trackArrival(this.currentStep);
    }
  }

  function init() {
    const root = document.getElementById('ym-quiz-lead');
    if (!root) return;
    window.__ymQuizLead = new YMQuiz(root);
    window.__ymQuizLead.start();
    console.info('[ym-quiz-lead] initialized · locale=' + window.__ymQuizLead.locale);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
